// constantApi.js
const constantApi = {
    // baseUrl: "http://192.168.18.221:8001/"
    baseUrl: "https://api.vallabhiesdiagnostic.com/"
};

export default constantApi;
